import * as React from 'react'

export const AuthSeparator = () => (
  <div className='auth-buttons-separator-container'>
    <div className='auth-buttons-separator-line-container'>
      <div className='auth-buttons-separator-line' />
    </div>
    <div className='auth-buttons-separator-text-container'>
      <div className='auth-buttons-separator-text'>Or</div>
    </div>
    <div className='auth-buttons-separator-line-container'>
      <div className='auth-buttons-separator-line' />
    </div>
  </div>
)
